const getters = {
  userInfo: state => state.app.userInfo,
  isMobile: state => state.app.isMobile,
  publishStatus: state => state.app.publishStatus,
  operateCode: state => state.app.operateCode,
  shareList: state => state.app.shareList
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js